module.exports = __webpack_public_path__ + "static/media/app_icon_rounded.2de41ec2.png";